// extracted by mini-css-extract-plugin
export var newsletter = "newsletter-module--newsletter--ct10J";
export var text = "newsletter-module--text--nlaZk";
export var title = "newsletter-module--title--l2XFu";